/* WW: sticky add to cart bar on mobile product pages.
   Appears when the main Add to Cart button scrolls out of view above the viewport.
   Clicking it clicks the real button, so AJAX cart, flavour picker validation
   and sold out states all behave exactly as normal. */
(function () {
  var init = function () {
    if (!document.body.classList.contains('template-product')) return;
    var realBtn = document.querySelector('.product-single__form [data-add-to-cart]');
    if (!realBtn) return;

    var mq = window.matchMedia('(max-width: 768px)');
    var titleEl = document.querySelector('.product-single__title') || document.querySelector('h1');
    var priceEl = document.querySelector('[data-product-price]') || document.querySelector('.product__price');

    var bar = document.createElement('div');
    bar.className = 'ww-sticky-atc';
    bar.innerHTML =
      '<div class="ww-sticky-atc__info">' +
      '<div class="ww-sticky-atc__title"></div>' +
      '<div class="ww-sticky-atc__price"></div>' +
      '</div>' +
      '<button type="button" class="ww-sticky-atc__btn"></button>';
    bar.querySelector('.ww-sticky-atc__title').textContent = titleEl ? titleEl.textContent.trim() : '';
    bar.querySelector('.ww-sticky-atc__price').textContent = priceEl ? priceEl.textContent.trim().split('\n')[0] : '';

    var btn = bar.querySelector('.ww-sticky-atc__btn');
    var syncBtn = function () {
      btn.textContent = (realBtn.textContent || 'Add to cart').trim();
      btn.disabled = realBtn.disabled;
    };
    syncBtn();
    btn.addEventListener('click', function () {
      realBtn.click();
      bar.classList.remove('is-visible');
    });

    document.body.appendChild(bar);

    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var scrolledPast = e.boundingClientRect.top < 0;
      if (!e.isIntersecting && scrolledPast && mq.matches) {
        syncBtn();
        bar.classList.add('is-visible');
      } else {
        bar.classList.remove('is-visible');
      }
    }, { threshold: 0 });
    io.observe(realBtn);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
